import type { TableColumnConfig } from '@pct-ng/feature-table-material';
import { TextEllipsisCellComponent } from '@pct-ng/feature-table-material';
import type { TranslateAbleText } from '@pct-ng/i18n';

export function createLongTextColumn<T>(
  id: string,
  field: keyof T,
  label: TranslateAbleText,
  sortable = false,
): TableColumnConfig<T> {
  return {
    id,
    field,
    label,
    cellContent: TextEllipsisCellComponent,
    sortable,
  };
}
